import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Text, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'
import MessageSystem from '../MessageSystem'
import { mediaQueries } from 'hotel-component-helpers'
import { Close } from 'pcln-icons'

const propTypes = {
  animationDelay: PropTypes.string,
  animationStickinessDelay: PropTypes.string,
  bottom: PropTypes.bool,
  handleCloseClick: PropTypes.func,
  iconColor: PropTypes.string,
  iconName: PropTypes.string,
  imageUrl: PropTypes.string,
  imageIcon: PropTypes.func,
  leftBarColor: PropTypes.string,
  persist: PropTypes.bool,
  renderDynamicContent: PropTypes.func,
  renderHeaderContent: PropTypes.func,
}

const StyledResponsiveImg = styled.img`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  box-shadow: 0 0 0px 1px ${getPaletteColor('border.base')};

  ${mediaQueries.phoneOnly`
    width: 56px;
    height: 56px;
  `}
`

const CursorClose = styled(Close)`
  cursor: pointer;
`

const IconBox = styled(Box)`
  height: 32px;
`

const StyledImgWrap = styled(Box)`
  height: 72px;
  ${mediaQueries.phoneOnly`
    height: 56px;
  `}
`

const NotificationImage = ({
  animationDelay,
  animationStickinessDelay,
  bottom,
  handleCloseClick,
  imageIcon,
  imageUrl,
  leftBarColor,
  persist,
  renderDynamicContent,
  renderHeaderContent,
}) => {
  const props = {
    bottom,
    leftBarColor,
    animationDelay,
    animationStickinessDelay,
    persist,
    messageComponent: (
      <Flex justifyContent='space-between' pb={2}>
        <StyledImgWrap width={['56px', '72px']} mx={2} mt={2}>
          {imageUrl && <StyledResponsiveImg src={imageUrl} />}
          {imageIcon && imageIcon()}
        </StyledImgWrap>
        <Flex flexDirection='column'>
          <Flex justifyContent='space-between'>
            <Text fontSize={[1, 2]} lineHeight='24px' ml={2} mr={1} my={1}>
              {renderHeaderContent && renderHeaderContent()}
            </Text>
            <IconBox width={32} p={1}>
              <CursorClose
                data-unit-id='NOTIFICATION_CLOSE'
                onClick={handleCloseClick}
                color='text.dark'
                size={24}
              />
            </IconBox>
          </Flex>
          <Text fontSize={[0, 1]} mt={[0, 1]} mr={1} mb={[0, 1]} ml={2}>
            {renderDynamicContent && renderDynamicContent()}
          </Text>
        </Flex>
      </Flex>
    ),
  }
  return <MessageSystem {...props} />
}

NotificationImage.propTypes = propTypes
NotificationImage.defaultProps = {
  bottom: false,
}
export default NotificationImage
